import { Text } from 'components/typography';
import { css } from '@emotion/react';

const ProductLabel = ({ text }: { text: string }) => (
  <Text
    fontFamily="header"
    fontSize={1}
    lineHeight={1.5}
    fontWeight="bold"
    textAlign={['center', 'right']}
    color="darkGrey"
    px={2}
    py={1}
    borderRadius="15px"
    position="absolute"
    right={[0, 3]}
    bottom={[2, 3]}
    backgroundColor="#FFFFFF"
    css={theme => css`
      max-width: 100%;
      box-shadow: ${theme.shadows.medium};

      &::selection {
        user-select: none;
      }

      @media ${theme.mediaQueries.mobileOnly} {
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        left: 0;
      }
    `}
  >
    {text}
  </Text>
);

export default ProductLabel;
